function install(app, rootVar) {
    // eslint-disable-next-line no-undef
    app.config.globalProperties.formatFontSize = formatFontSize.bind(null, rootVar);
}

export default install;
